import {graphql} from 'gatsby'
import ContactSection from './../components/contact-section'
import EDesignSection from './../components/e-design-section'
import HoldingPageHeroImage from './../components/holding-page-hero-image'
import Layout from './../components/layout'
import React, {useState} from 'react'
import {E_DESIGN_SECTION_CSS_MODIFIER, HOLDING_PAGE_CSS_MODIFIER, PAGE_ROOT_ELEMENT_ID} from './../constants/global-constants'

export default props => {
  const [edesignPackageLevel, setEdesignPackageLevel] = useState('')
  const {data} = props
  const prismicData = {
    showTheHoldingPage: data.prismicHoldingPage.data.show_the_holding_page,
  }

  return (
    <Layout
      documentTitlePrefix="E-DESIGN"
      isIndexPage={false}
      pageName="e-design"
      showScrollToTopBtn={false}
      showTheHoldingPage={prismicData.showTheHoldingPage}
    >
      {prismicData.showTheHoldingPage ? (
        <>
          <HoldingPageHeroImage />
          <ContactSection cssModifier={HOLDING_PAGE_CSS_MODIFIER} />
        </>
      ) : (
        <>
          <EDesignSection cssModifier={E_DESIGN_SECTION_CSS_MODIFIER} />
        </>
      )}
    </Layout>
  )
}

export const pageQuery = graphql`
  {
    prismicHoldingPage {
      data {
        show_the_holding_page
      }
    }
  }
`
